export class Forbidden {
  type = 'Forbidden';
}
